let customEvents = {
    modalopened: new CustomEvent('modalopened'),
    modalclosed: new CustomEvent('modalclosed')
};

export default customEvents;
